import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GtwElementsBaseUrlsModel } from '../../../../app/shared/_models/gtw-elements-base-urls.model';
import { SourcingDefaultMeService } from './sourcing-default-me.service';
import * as _ from 'lodash-es';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  extractObject,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen
} from '../../../shared/workspace-element-context';
import {
  findAppkitItemByValue,
  getAppkitDropdownSelection,
  setDropdownAriaLabel
} from '../../../shared/utils/appkit-dropdown.util';

@Component({
    selector: 'gtw-sourcing-default-me',
    templateUrl: './sourcing-default-me.component.html',
    styleUrls: ['./sourcing-default-me.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SourcingDefaultMeComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);
  private readonly host = inject(ElementRef<HTMLElement>);

 
  baseGlobalParams: any;
  baseURLs: GtwElementsBaseUrlsModel ={'admin':'','api':'/gtw',"custom":'','efile':'','pdfEngine':'','bulkPdfEngine':''};
  private baseURL = '/custom';
  private baseURLGtw = '/gtw';
  private taxYear :number = 0;
  private scenario :number = 0;
  private jcdKey :number = 0;
  private screenKey :number = 0;
  private filingKey :number = 0;
  private acctKey :number = 0;
  private ssoId: string = '';
  acctType:string = '';
  private parentMeKey :number = 0;
  private scenarioCode: string = '';
  private checkLockedObj: any[] = [];
  basket_id_value: any;



  

  @Output('close-modal')
  closeModal = new EventEmitter<void>();

  @Output('request-grid-update')
  requestGridUpdate = new EventEmitter<string>();

  subscriptions:Subscription = new Subscription() ;


  constructor(
    private SourcingDefaultMeService: SourcingDefaultMeService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) { }

  minimise = false;

  SavedData : any = [];
  basketIdList : any = []; 
  baseIdList : any = [];
  basketIdListView : any = [];
  baseIdListView : any = [];
  selectedBasketid  : any = null;
  selectedBaseid  : any = null;
  selectedBasketItem: any = null;
  selectedBaseItem: any = null;
  scenarioDesc: string = '';  
	durationInSeconds= 5;
	CheckBasketFlag = false;
  BasketCheck: any = [];
  BaseCheck:any = [];
  tempGroupData : any = { };
  isResetBasketFlag = false;
  isResetBaseFlag = false;

  checkInputType():boolean{
		if(Number.isInteger(parseInt(this.taxYear+"")) &&
		  Number.isInteger(parseInt(this.scenario+'')) &&
		  Number.isInteger(parseInt(this.jcdKey +'')) &&
		  Number.isInteger(parseInt(this.screenKey+'')) &&
		  Number.isInteger(parseInt(this.ssoId+""))&&
      Number.isInteger(parseInt(this.parentMeKey+"")) &&
      Number.isInteger(parseInt(this.filingKey+""))&&
      Number.isInteger(parseInt(this.acctKey+""))&&
      Number.isInteger(parseInt(this.acctType+""))
		  )
		{
		  return true;
		}
	
		return false;
	}


  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.tryInit();
    this.subscriptions.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.subscriptions.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const fp = normalizeFilterParams(activeScreen);
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.baseGlobalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || {};
    this.scenarioCode = String(this.baseGlobalParams?.scenarioCode ?? this.scenarioCode ?? '');
    this.taxYear = Number(fp?.tax_year ?? this.baseGlobalParams?.tax_year ?? this.taxYear ?? 0);
    this.scenario = Number(fp?.scenario ?? this.baseGlobalParams?.scenario ?? this.scenario ?? 0);
    this.jcdKey = Number(fp?.jcd_key ?? this.baseGlobalParams?.jcd_key ?? this.jcdKey ?? 0);
    this.screenKey = Number(fp?.screen_key ?? this.baseGlobalParams?.screen_key ?? this.screenKey ?? 0);
    this.filingKey = Number(fp?.filing_key ?? this.baseGlobalParams?.filing_key ?? this.filingKey ?? 0);
    this.acctKey = Number(fp?.acct_key ?? this.baseGlobalParams?.acct_key ?? this.acctKey ?? 0);
    this.parentMeKey = Number(fp?.parent_me_key ?? fp?.me_key ?? this.baseGlobalParams?.me_key ?? this.parentMeKey ?? 0);
    const at = fp?.acct_type ?? this.baseGlobalParams?.acct_type;
    this.acctType = at != null && at !== '' ? String(at) : this.acctType;
    const sso = this.gtwApp?.USER_SETTINGS?.user?.sso_id;
    this.ssoId = sso != null && sso !== '' ? String(sso) : this.ssoId;
    const row = rowPayloadFromActiveScreen(activeScreen);
    const rowObj = Array.isArray(row) ? (row[0]?.data ?? row[0]) : extractObject(row);
    if (rowObj && Object.keys(rowObj).length) {
      if (rowObj.ACCT_KEY != null) this.acctKey = Number(rowObj.ACCT_KEY);
      if (rowObj.FILING_KEY != null) this.filingKey = Number(rowObj.FILING_KEY);
      if (rowObj.PARENT_ME_KEY != null) this.parentMeKey = Number(rowObj.PARENT_ME_KEY);
      else if (rowObj.ME_KEY != null) this.parentMeKey = Number(rowObj.ME_KEY);
      if (rowObj.ACCT_TYPE != null) this.acctType = String(rowObj.ACCT_TYPE);
      else if (rowObj.acct_type != null) this.acctType = String(rowObj.acct_type);
      const meCode = rowObj.ME_CODE ?? rowObj.me_code;
      if (meCode != null && meCode !== '') {
        this.checkLockedObj = [{
          me_code: meCode,
          consol_group_key: this.filingKey,
          scenario_key: this.scenario,
          tax_year: this.taxYear,
          scenarioCode: this.scenarioCode,
          is_issue_key_enabled: String(this.baseGlobalParams?.is_issue_key_enabled ?? 'N'),
        }];
      }
    }
  }

  init() {   
    if(this.checkInputType()){
			this.getBaksetIdData();
     // this.getBaseIdData();
     // this.getModalSaveData();
      }
    } 

  private tryInit(): void {
    if (!this.checkInputType()) {
      return;
    }
    this.init();
  }


  modalClose(): void {
    this.closeModal.emit();
  }
   
    onBasketChange(): void {
      this.CheckBasketFlag = false;
    }

    onBaseChange(): void {
      this.CheckBasketFlag = false;
    }

    onBasketDropdownChange(event: any): void {
      const selected = getAppkitDropdownSelection(event);
      this.selectedBasketItem = selected;
      this.selectedBasketid = selected?.value ?? null;
      this.onBasketChange();
    }

    onBaseDropdownChange(event: any): void {
      const selected = getAppkitDropdownSelection(event);
      this.selectedBaseItem = selected;
      this.selectedBaseid = selected?.value ?? null;
      this.onBaseChange();
    }

    /**
     * AppKit ap-dropdown portals via CDK overlay (not the MatDialog DOM).
     * Clamp the open list to remaining space inside this dialog so options
     * do not spill onto the grid behind the modal.
     */
    onSourcingDropdownVisible(event: { dropdownStatus?: boolean } | boolean): void {
      const open = typeof event === 'boolean' ? event : !!event?.dropdownStatus;
      if (!open) {
        return;
      }
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.clampOpenDropdownToDialog());
      });
    }

    private clampOpenDropdownToDialog(): void {
      const hostEl = this.host.nativeElement;
      const dialogEl =
        (hostEl.closest('.mat-mdc-dialog-container') as HTMLElement | null) ||
        (hostEl.closest('.mat-dialog-container') as HTMLElement | null) ||
        (hostEl.closest('.cdk-overlay-pane') as HTMLElement | null);
      if (!dialogEl) {
        return;
      }

      const dialogRect = dialogEl.getBoundingClientRect();
      const trigger = hostEl.querySelector('.SourcingDropdown .ap-dropdown-select') as HTMLElement | null;
      const triggerRect = trigger?.getBoundingClientRect();
      const lists = Array.from(
        document.querySelectorAll<HTMLElement>('.cdk-overlay-pane .ap-dropdown-list')
      );
      if (!lists.length) {
        return;
      }

      // Pick the list nearest this modal's trigger (avoids touching other open dropdowns).
      let target = lists[0];
      if (triggerRect) {
        let best = Number.POSITIVE_INFINITY;
        for (const list of lists) {
          const r = list.getBoundingClientRect();
          const dist =
            Math.abs(r.left - triggerRect.left) + Math.abs(r.top - triggerRect.bottom);
          if (dist < best) {
            best = dist;
            target = list;
          }
        }
      }

      const listRect = target.getBoundingClientRect();
      const availableBelow = Math.floor(dialogRect.bottom - listRect.top - 8);
      if (availableBelow >= 72) {
        target.style.maxHeight = `${Math.min(availableBelow, 220)}px`;
        target.style.overflowY = 'auto';
        return;
      }

      // List opened with little/no room below the field: keep a short scrollable
      // panel and nudge CDK so adaptive positioning can flip upward if possible.
      target.style.maxHeight = '160px';
      target.style.overflowY = 'auto';
      window.dispatchEvent(new Event('resize'));
    }

    setDropdownAriaLabel(item: any, contextLabel: string = 'Option'): string {
      return setDropdownAriaLabel(item, contextLabel);
    }

    onDropdownSelectItem(event: any): void {
      const selected = getAppkitDropdownSelection(event);
      if (selected) {
        if (this.basketIdListView?.includes(selected) || this.basketIdListView?.some((i: any) => i?.value === selected?.value)) {
          this.selectedBasketItem = selected;
        }
        if (this.baseIdListView?.includes(selected) || this.baseIdListView?.some((i: any) => i?.value === selected?.value)) {
          this.selectedBaseItem = selected;
        }
      }
    }

    private syncBasketSelection(): void {
      this.selectedBasketItem = findAppkitItemByValue(this.basketIdListView, this.selectedBasketid);
    }

    private syncBaseSelection(): void {
      this.selectedBaseItem = findAppkitItemByValue(this.baseIdListView, this.selectedBaseid);
    }


      getBaksetIdData(){
        this.basketIdList = [];
        this.SourcingDefaultMeService.getBaksetIdData(this.baseURLs.api, this.baseGlobalParams,this.ssoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
          if (data) {
            let tempIssueId : any = [];
            data.forEach( (value : any, i: any) => {
                let tempChannel = {
                  value: value.BASKET_ID,
				          index: i,
                  label: value.BASKET_NAME,
                  selected:false
                }
                tempIssueId.push(tempChannel);
            });
            this.basketIdList = tempIssueId;
            this.basketIdListView = this.basketIdList;
            console.log(this.basketIdList);
            this.getBaseIdData();
          }
        },error => {
			console.log(error);
		});
    
        
      }  


      getBaseIdData(){
        this.baseIdList = [];
        this.SourcingDefaultMeService.getBaseIdData(this.baseURLs.api, this.baseGlobalParams).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
          if (data) {
            //let tempBaseId : any = [];
            data.forEach( (dataValue : any, i: any) => {
				    this.baseIdList.push(
				      {
                  value: dataValue.BASE_ID,
				          index: i,
                  label: dataValue.BASE_NAME,
                  selected:false
                }
				);
                
            });
           // this.baseIdList[0].data[0].selected =  true;
            this.baseIdListView = this.baseIdList;
            console.log(this.baseIdList);
            this.getModalSaveData();
          }
        },error => {
          console.log(error);
        });
    }  


      getModalSaveData(){
        if(this.SavedData.length == 0 ) {
          this.SourcingDefaultMeService.getSourcingModalData(this.baseURLs.api, this.baseGlobalParams, this.acctKey,this.parentMeKey,this.filingKey).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
            if (data.length > 0) {
              console.log(data);
              this.SavedData = data;
              ///this.getModalPopulateData();

        this.basket_id_value = this.SavedData[0].BASKET_ID;
        var base_id_value = this.SavedData[0].BASE_ID;

        if(this.SavedData[0].BASKET_ID !== 0 ){
          var selectedbasketIndex= _.findIndex(this.basketIdList, { value: this.basket_id_value});
          this.basketIdList[selectedbasketIndex].selected = true;
          this.basketIdList = JSON.parse(JSON.stringify(this.basketIdList));
          this.basketIdListView = this.basketIdList;
          this.selectedBasketid = this.basketIdList[selectedbasketIndex].value;
          this.syncBasketSelection();


        }
          if (this.SavedData[0].BASE_ID !==0){        
            var selectedbaseIndex= _.findIndex(this.baseIdList, { value: base_id_value});
          this.baseIdList[selectedbaseIndex].selected = true;
          this.baseIdList = JSON.parse(JSON.stringify(this.baseIdList));
          this.baseIdListView = this.baseIdList;
          this.selectedBaseid = this.baseIdList[selectedbaseIndex].value;
          this.syncBaseSelection();
          }  
            }
          },
            (error: any) => {
            console.log(error);
          }, () => {
            console.log('Completed loading');
          });
        }
      }

      getModalPopulateData(){
        
      }
      


  saveData(){ 
    this.BasketCheck = (this.selectedBasketid === null || this.selectedBasketid === undefined || this.selectedBasketid === '') ? 0 : this.selectedBasketid;
    this.BaseCheck = (this.selectedBaseid === null || this.selectedBaseid === undefined || this.selectedBaseid === '') ? 0 : this.selectedBaseid;


    if(this.BasketCheck == 0 && this.BaseCheck ==0){
       this.CheckBasketFlag = true;
          return;
        }else{
          this.CheckBasketFlag = false;
        };

    

   let tempData = {
     TAX_YEAR : this.baseGlobalParams?.tax_year,
     SCENARIO : this.baseGlobalParams?.scenario,
     JCD_KEY : this.baseGlobalParams?.jcd_key,
     SSO_ID: this.ssoId,
     ME_KEY:this.parentMeKey,
     ACCT_KEY:this.acctKey,
     FILING_KEY:this.filingKey,
     BASKET_ID : this.BasketCheck,//this.basketIdList[0].data[_.findIndex(this.basketIdList[0].data, { 'selected': true})].value ,
     BASE_ID: this.BaseCheck//this.baseIdList[0].data[_.findIndex(this.baseIdList[0].data, { 'selected': true})].value 
   }

  
   const updateSubscription = this.SourcingDefaultMeService.saveSourcingInfoData(
     this.baseURLs.api,
     tempData,
     this.baseGlobalParams,
     this.checkLockedObj
   ).subscribe({
     next: (data) => {
       if (data.callSuccess == '1') {
         this.SourcingDefaultMeService.openSnackBar('Data Saved Successfully', 'gtw-snackbar--green');
         this.requestGridUpdate.emit('refresh');
       } else {
         this.SourcingDefaultMeService.openSnackBar('Error Saving Data. ' + data.errorMessage, 'gtw-snackbar--red');
       }
     },
     error: (err) => {
       const msg = err?.error?.errorMessage ?? err?.message ?? '';
       this.SourcingDefaultMeService.openSnackBar('Entity Chart update failed. ' + msg, 'gtw-snackbar--red');
     },
   });
   this.subscriptions.add(updateSubscription);
 };


 resetData(){
  this.CheckBasketFlag = false;
  this.selectedBasketid = null;
  this.selectedBaseid = null;
  this.selectedBasketItem = null;
  this.selectedBaseItem = null;
  this.syncBasketSelection();
  this.syncBaseSelection();
  this.basketIdList.forEach((b: any) => (b.selected = false));
  this.baseIdList.forEach((b: any) => (b.selected = false));
}

}

